// extracted by mini-css-extract-plugin
module.exports = {"container":"printer_container__Hf9Mo","virtual-agent-area":"printer_virtual-agent-area__lSfdw"};